import { Stack, TextField } from '@mui/material';
import { useFormikContext } from 'formik';

const WebsiteDetails = () => {
  const { values, handleChange } = useFormikContext<{ title: string }>();

  return (
    <Stack>
      <TextField
        label="Título"
        name="title"
        margin="normal"
        fullWidth
        size="small"
        value={values.title}
        onChange={handleChange}
      />
    </Stack>
  );
};

export default WebsiteDetails;
